"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const core_1 = require("@material-ui/core");
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const useNav_1 = __importDefault(require("../useNav"));
function Link(props) {
    const { style, href, children = '', target, noWrap, onClick } = props;
    const { goTo, openTo } = (0, useNav_1.default)();
    const value = react_1.default.isValidElement(children) ? (react_1.default.cloneElement(children, { color: 'link' })) : (react_1.default.createElement(Text_1.default, { color: "link", noWrap: noWrap, withEllipsis: noWrap }, children));
    const handleClick = (0, react_1.useCallback)(e => {
        const meta = e.metaKey;
        if ((href === null || href === void 0 ? void 0 : href.startsWith('http://')) || (href === null || href === void 0 ? void 0 : href.startsWith('https://'))) {
            openTo(href, undefined, target);
        }
        else if (href && meta) {
            openTo(href);
        }
        else if (href) {
            goTo(href);
        }
        else if (onClick) {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }
    }, [goTo, href, onClick, openTo, target]);
    return (react_1.default.createElement(core_1.Link, { target: target, style: Object.assign({ cursor: 'pointer', overflow: 'hidden' }, (style || {})), underline: "none", onClick: handleClick }, value));
}
exports.Link = Link;
exports.default = Link;
